export const PROGRAM_OPTIONS = [
	{
		key: 'Online',
		value: 'Online',
		label: 'Leangap Online',
		description: 'June 14 to July 9, 2027 · $6,450 USD',
		note: 'Join from anywhere via Zoom and Discord',
	},
	{
		key: 'San Francisco',
		value: 'San Francisco',
		label: 'Leangap San Francisco',
		description: 'July 12 to August 6, 2027 · $14,950 USD',
		note: 'Hosted at UC Berkeley in California',
	},
] as const
